module.exports = "../fonts/no_requests.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no_requests.svg
// module id = 25
// module chunks = 0